import { render } from "./DeleteBooking.vue?vue&type=template&id=d74d416e"
import script from "./DeleteBooking.vue?vue&type=script&lang=js"
export * from "./DeleteBooking.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3233614911/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__